import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { FirebaseAuthContext } from '../../auth/FirebaseAuth';

const ProtectedRoute = ({ children }) => {
  const { firebaseAuth } = useContext(FirebaseAuthContext);
  const location = useLocation();

  // Fast-path: if the localStorage flags are present the user was logged in during
  // the previous session — skip the loading state so there is no visible flash.
  const hasLocalFlag =
    !!localStorage.getItem('isUserLoggedIn') ||
    !!localStorage.getItem('cscOwnerLoggedIn');

  const [authState, setAuthState] = useState({
    loading: !hasLocalFlag && !firebaseAuth.currentUser,
    authed: !!firebaseAuth.currentUser || hasLocalFlag,
  });

  useEffect(() => {
    const unsub = onAuthStateChanged(firebaseAuth, (user) => {
      setAuthState({ loading: false, authed: !!user });
      // Keep localStorage in sync: if Firebase says "no user", clear stale flags.
      if (!user) {
        localStorage.removeItem('isUserLoggedIn');
        localStorage.removeItem('cscOwnerLoggedIn');
      }
    });
    return unsub;
  }, [firebaseAuth]);

  if (authState.loading) {
    // Brief pause while Firebase resolves the session — renders nothing visible.
    return <div className="auth-checking" aria-hidden="true" />;
  }

  if (!authState.authed) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ProtectedRoute;
